(function ($) {

	var initializeBlock = function ($block) {

		var container = $block,
			control = container.find('.icon-tabs__control-item'),
			content = container.find('.icon-tabs__content-item'),
			active = 0;

		function updateActive(index) {
			gsap.timeline()
				.to(control, { flexBasis: '7.5rem' })
				.to(control.eq(index), { flexBasis: '15rem' }, '<')
				.duration(0.5);

			gsap.timeline()
				.to(content, { autoAlpha: 0 })
				.to(content.eq(index), { autoAlpha: 1 })
				.duration(0.5);
		}

		updateActive(active);

		control.on("click", function () {
			updateActive($(this).index());
		});

	}

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('.icon-tabs').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=icon-tabs', initializeBlock);
	}

})(jQuery);
